// extracted by mini-css-extract-plugin
export default {"column":"order-page-sidebar_column__iFRlH"};